/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * The modal popup to show Wizard summary
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.2.0
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { IRootReducer } from '../../../reducers/rootReducer';
import { makeSelectWizardTranslation } from '../../internationalization/intSelectors';
import { IWizardTranslation } from '../../internationalization/types/wizards/wizard';
import Modal from '../../modal/components/Modal';
import ModalOrder from '../../modal/components/ModalOrder';
import { IModalPopup } from '../../modal/components/ModalPopup';
import { EWizardName } from '../wizardConstants';
import { makeSelectWizardName } from '../wizardSelectors';

interface IWizardModalSummary {
    onCloseButtonClick: () => void;
    orderId?: number | string;
    orderType?: string;
}

interface IConnectedProps {
    wizardName: EWizardName;
    wizardTranslation: IWizardTranslation;
}

type TWizardModalSummary = IWizardModalSummary & IConnectedProps & Pick<IModalPopup, 'onCloseModal' | 'dataName'>;

export const WizardModalSummary = (props: TWizardModalSummary) => {
    const {
        dataName,
        orderId,
        orderType,
        wizardName,
        wizardTranslation,

        onCloseButtonClick,
        onCloseModal,
    } = props;

    const orderName = orderType || wizardTranslation.wizardModalSummary.orderName[wizardName] || String(orderId);

    return (
        <Modal dataName={dataName} width="590px">
            <ModalOrder
                orderId={orderId}
                orderName={orderName}
                onCloseButtonClick={onCloseButtonClick}
                onCloseModal={onCloseModal}
            />
        </Modal>
    );
};

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    wizardTranslation: makeSelectWizardTranslation(),
    wizardName: makeSelectWizardName(),
});

export default connect(mapStateToProps)(WizardModalSummary);
